import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import useAccountMenu from '../../../../../../tickchakHooks/useAccontMenu';
import {menuEvent} from '../../../../../../layout/menu';
import {getPageTitle} from '../../../../../../layout/navigation/Navigation';
import {pathNormalization} from '../pathNormalization';

export interface LinkOption {
    key: string;
    label: string;
    path: string;
    group: 'account' | 'event' | 'general';
}

export function useLinkOptions(): LinkOption[] {
    const layoutT = useTranslation('layout');
    const type = useSelector((s: any) => s.event?.type);
    const accountMenu = useAccountMenu();

    const accountMenuData = useMemo(() => accountMenu(), [accountMenu]);

    return useMemo(() => {
        const options: LinkOption[] = [];

        const usesPackageListClick = ['team', 'subscription', 'package'];

        accountMenuData.arr.forEach(item => {
            if(item.onClick) {
                const path = usesPackageListClick.includes(item.text)
                    ? `/p/pid/home?packagePage=${item.text}`
                    : `/p/pid/${item.text}`;

                options.push({
                    key: item.key,
                    label: layoutT.t(item.title || item.text) || item.title || item.text,
                    path,
                    group: 'account'
                });
            }
        });

        const seenTitles = new Set();
        Object.entries(menuEvent).forEach(([key, item]) => {
            if(item.menu?.includes('main') && key !== 'eventCluster' && key !== 'teamCluster') {
                const title = getPageTitle(type, layoutT.t, item.title) || layoutT.t(item.title);
                if(!seenTitles.has(title)) {
                    seenTitles.add(title);
                    const {normalized, isBranding} = pathNormalization(item.path);
                    options.push({
                        key,
                        label: title,
                        path: isBranding ? `/e/eid/eventType/${normalized}` : `/e/eid${item.path}`,
                        group: 'event'
                    });
                }
            }
        });

        options.push({
            key: 'support',
            label: layoutT.t('support'),
            path: '/support',
            group: 'general'
        });

        return options;
    }, [layoutT.t, accountMenuData]);
}
